import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=f7de4ca2&scoped=true"
import script from "./ChannelEdit.vue?vue&type=script&lang=js"
export * from "./ChannelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7de4ca2",
  null
  
)

export default component.exports